import { render } from "./NewCategoryModal.vue?vue&type=template&id=1cdfa6be&scoped=true"
import script from "./NewCategoryModal.vue?vue&type=script&lang=js"
export * from "./NewCategoryModal.vue?vue&type=script&lang=js"

import "./NewCategoryModal.vue?vue&type=style&index=0&id=1cdfa6be&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdfa6be"]])

export default __exports__